import {
  Screen,
  SearchFormScreen,
  ResultsScreen,
  InfoScreen,
  AbcGuideScreen,
  SourcesScreen,
  TuneLinksScreen,
} from "./AppScreens";

const LinkSlide = ({ info, results, fame }) => (
  <>
    <SearchFormScreen query={info?.url || "https://tidal.com/track/…"} fame={fame} slim />
    <ResultsScreen
      results={results || []}
      linkInfo={info}
      note={info ? `${info.source}: ${info.artist.replace("|", " · ")} — ${info.title}` : ""}
    />
  </>
);

// real app screens for the search / link / guide slides
export const ScreenSlide = ({ kind, dark, zoom, demo, tune }) => {
  const fame = Math.round(tune?.fame_score || 80);
  let body = null;
  if (kind === "screen-name")
    body = (
      <>
        <SearchFormScreen query="cooley" fame={fame} slim />
        <ResultsScreen results={demo.name} note="most relevant matches first" />
      </>
    );
  if (kind === "screen-typekey")
    body = <SearchFormScreen type="reel" tkey="Edorian" lists={{ types: demo.types || [], keys: demo.keys || [] }} />;
  if (kind === "screen-notes")
    body = (
      <>
        <SearchFormScreen mode="notes" query="FAA BAA" fame={fame} slim />
        <ResultsScreen results={demo.notes} note="tunes containing these notes · most famous first" />
      </>
    );
  if (kind === "screen-link") body = <LinkSlide info={demo.link} results={demo.linkResults} fame={fame} />;
  if (kind === "screen-album") body = <LinkSlide info={demo.album} results={demo.albumResults} fame={fame} />;
  if (kind === "screen-fame") body = <SearchFormScreen fame={fame} />;
  if (kind === "screen-info" && tune) body = <InfoScreen tune={tune} />;
  if (kind === "screen-abcguide") body = <AbcGuideScreen />;
  if (kind === "screen-sources") body = <SourcesScreen />;
  if (kind === "screen-tunelinks")
    body = <TuneLinksScreen tune={demo.linkResults?.[0] || tune} source={demo.link?.source} />;
  return body ? (
    <Screen dark={dark} zoom={zoom}>
      {body}
    </Screen>
  ) : null;
};
